import React from 'react'
import { currencyFormat } from './arAgingModel'

// Six click-to-filter tiles. Values reflect the FILTERED set so they always
// match the list. Bucket tiles toggle an exact-bucket filter, Past Due toggles
// any-past-due, Total clears both. (Same rule as the prior prod component.)
const TILES = [
  { key: 'total', label: 'Total AR' },
  { key: 'pastDue', label: 'Past Due', risk: true },
  { key: 'age30', label: '1-30' },
  { key: 'age60', label: '31-60' },
  { key: 'age90', label: '61-90', risk: true },
  { key: 'age90Plus', label: '90+', risk: true }
]

const ArStatTiles = ({ totals, filters, onFilterChange }) => (
  <section className="ar-tiles">
    {TILES.map(tile => {
      const active = tile.key === 'pastDue' ? filters.pastDueOnly : filters.bucket === tile.key
      const onClick = () => {
        if (tile.key === 'total') return onFilterChange({ ...filters, bucket: '', pastDueOnly: false })
        if (tile.key === 'pastDue') return onFilterChange({ ...filters, pastDueOnly: !filters.pastDueOnly, bucket: '' })
        return onFilterChange({ ...filters, bucket: active ? '' : tile.key, pastDueOnly: false })
      }
      const risk = tile.risk && totals[tile.key] > 0
      return (
        <button
          key={tile.key}
          type="button"
          className={`ar-tile ${active ? 'active' : ''} ${risk ? 'risk' : ''}`}
          onClick={onClick}
          title={tile.key === 'total'
            ? 'Clear bucket filters'
            : (active ? 'Clear this filter' : `Only show properties with a ${tile.label} balance`)}
        >
          <div className="ar-tile-label">{tile.label}{active ? ' ✕' : ''}</div>
          <div className="ar-tile-value">{currencyFormat(totals[tile.key])}</div>
        </button>
      )
    })}
  </section>
)

export default ArStatTiles
